export const applicationLabels = { pending: '待审批', approved: '已同意', rejected: '已拒绝', withdrawn: '已撤回' };
// 同一申请在通知、评论、管理和个人中心中保持相同的状态配色。
export const applicationColors = { pending: 'warning', approved: 'success', rejected: 'error', withdrawn: 'default' };
export const applicationReason = reason => ({
  self_application: '发布者不能操作自己的申请', already_withdrawn: '已经撤回', already_pending: '正在等待审批',
  activity_completed: '活动已完成，参与名单已锁定', already_approved: '申请已经获批', publisher_unavailable: '发布者当前不可用',
  post_closed: '帖子已关闭', post_expired: '招募已过期', conversation_dissolved: '帖子群聊已解散',
  recruitment_full: '招募名额已满', recruitment_closed: '招募已关闭', not_approved: '申请尚未获批',
  activity_not_completed: '等待发布者标记活动完成', already_confirmed: '已经确认完成',
  participation_not_confirmed: '请先确认本人活动完成', review_already_submitted: '你已经提交评价，不能修改',
})[reason] || '当前不可操作';
